<ion-app>
  <ion-menu contentId="myMenuContent" id="myMenu" [swipeGesture]="false">
    <csi-mobilemenu (sendNav)="onTypeEmitted($event)" [activeMenuItem]="activeMenuItem" [civarMenu]="civarMenu" [quantumCivarMenu]="quantumCivarMenu"></csi-mobilemenu>
  </ion-menu>
  
  <csi-menuLat (sendNav)="onTypeEmitted($event)" *ngIf="isAuth" [civarMenu]="civarMenu" [quantumCivarMenu]="quantumCivarMenu" [hidden]="!showMenuLatDesktop"></csi-menuLat>

  <ion-router-outlet id="myMenuContent" [hidden]="!isOutSplashScreen"></ion-router-outlet>
</ion-app>
